module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/7.5165f098.png";